import {iosUserHttp} from './index'

function iosUserRequest(url, method, data) {
    return iosUserHttp({
        url: url,
        method: method,
        data: data
    })
}

export function clean(data) {
    return post('/user/clearIds', data)
}

function get(url, data) {
    return iosUserRequest(url, 'get', data)
}

function post(url, data) {
    return iosUserRequest(url, 'post', data)
}

export function shopItemStock() {
    return get('/shopping/current/stock')
}

export function searchUser(data) {
    return post('/cat/admin/search', data)
}

export function searchOrder(data) {
    return post('/shopping/admin/record', data)
}